import { memo, useMemo } from "react";
import { markMatch, prepareForMatching } from "@datassential/platform-ui-lib";
import { IMacItemObsolete } from "@apiHooks/useMacsListObsolete";
import MoreLabelObsolete from "./MoreLabelObsolete";

interface RowDescriptionObsoleteProps {
    query: string;
    row: IMacItemObsolete;
}

const RowDescriptionObsolete = ({ query, row }: RowDescriptionObsoleteProps) => {
    const sanitizedQuery = useMemo(() => prepareForMatching(query), [query]);
    const sanitizedAdditional = useMemo(
        () => prepareForMatching(row.description.additional),
        [row.description.additional]
    );
    const hasMatchInAdditional = useMemo(
        () => markMatch(sanitizedAdditional, sanitizedQuery, true).includes(sanitizedQuery),
        [sanitizedAdditional, sanitizedQuery]
    );
    const highlightedPreview = useMemo(
        () => sanitizedQuery === ''
            ? row.description.preview
            : markMatch(row.description.preview, sanitizedQuery, true),
        [sanitizedQuery, row.description.preview]
    );
    
    return (
        <div>
            <div
                className="MacsListTable__row-description-preview"
                dangerouslySetInnerHTML={{
                    __html: highlightedPreview
                }}
            />
            {' '}
            {row.itemsCount > 2 && (
                <MoreLabelObsolete
                    rowId={row.id} 
                    count={row.itemsCount - 2} 
                    isHighlighted={!!sanitizedQuery && hasMatchInAdditional} 
                />
            )}
        </div>
    );
};

export default memo(RowDescriptionObsolete);